import React from 'react';
import { HelpBlock } from 'react-bootstrap';

import Icon from './../ui/Icon';

export default ({ message }) => (
  <HelpBlock className="form-error">
    <Icon name="warning" /> {message}
  </HelpBlock>
);



// WEBPACK FOOTER //
// ./src/components/forms/FormError.js